import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=84267f02&"
import script from "./Folder.vue?vue&type=script&lang=ts&"
export * from "./Folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports